<sm-page-header [breadcrumb]="breadcrumb" />

<sm-data-table-builder
  [dataTableObject]="dataTableObject"
  [datas]="data"
  [loading]="loading"
  [totalRecords]="totalRecords"
/>

<sm-drawer #drawer [drawer]="delaisReglementairesDrawer" /> 